import { render, staticRenderFns } from "./KioskCard.vue?vue&type=template&id=2fc5b854&scoped=true&lang=pug"
import script from "./KioskCard.vue?vue&type=script&lang=js"
export * from "./KioskCard.vue?vue&type=script&lang=js"
import style0 from "./KioskCard.vue?vue&type=style&index=0&id=2fc5b854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5b854",
  null
  
)

export default component.exports